import React from "react"
import styled from "styled-components"
import { AosWrapper } from "../../molecules/AosWrapper"

const Wrapper = styled.div`
  padding: 80px 20px;
  position: relative;
  background: ${(props) => props.theme.bgSectorColor};

  @media (max-width: 600px) {
    padding: 40px 20px;
  }

  @media (min-width: 601px) and (max-width: 1023px) {
    padding: 50px 60px;
  }
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  max-width: 1212px;
  width: 100%;
  gap: 28px;
  @media (max-width: 1023px) {
    gap: 20px;
  }
`

export const CompanyDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 1023px) {
    gap: 12px;
  }
  .title-container {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
  }
  .title {
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 150%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: #fff;
    @media (max-width: 1023px) {
      font-size: 22px;
      text-align: start;
    }
  }
  p {
    font-family: Lato, sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0%;
    text-align: center;
    color: #ffffffcc;
    @media (max-width: 1023px) {
      font-size: 14px;
      font-weight: 400;
      text-align: start;
    }
  }
`

export const ButtonContainer = styled.div`
  margin-top: 4px;
  display: flex;
  gap: 8px;
  border-radius: 8px;
  color: #333333;
  padding: 18px 24px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 14px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: linear-gradient(
    87.75deg,
    #0058ee 0%,
    rgba(54, 215, 183, 0.8) 100%
  );
  @media (max-width: 600px) {
    width: 100%;
  }
  @media (max-width: 1023px) {
    padding: 13px 24px;
  }
`

export const Button = styled.button`
  box-sizing: border-box;
  width: fit-content;
  background-color: transparent;
  border: none;
  font-weight: 600;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
  @media (max-width: 1023px) {
    font-size: 14px;
  }
`
export const CompanyDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  @media (max-width: 1023px) {
    width: 100%;
    gap: 12px;
  }
`

export const Card = styled.div`
  opacity: 1;
  border-radius: 25px;
  border: 1px solid #242938;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .image {
    width: 40px;
    height: 40px;
  }

  @media (max-width: 1023px) {
    border-radius: 12px;
    .image {
      width: 32px;
      height: 32px;
    }
    padding: 12px;
  }
`
export const Title = styled.h1`
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #ffffff99;
  @media (max-width: 1023px) {
    font-size: 12px;
  }
`
export const Count = styled.p`
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 26px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  margin: 12px 0 2px 0;
  @media (max-width: 1023px) {
    font-size: 20px;
    margin-top: 8px;
  }
`

const StyledGradientTitle = styled.span`
  font-family: Montserrat, sans-serif;
  ${(props) => props.theme.typography.heroHeadline};
  background: ${(props) => props.theme.indicatorGradient};
  font-size: 30px;
  font-weight: 600;
  background-clip: text;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`
const impactfulData = [
  {
    iconSrc: "/assets/icons/software-developer.svg",
    title: "ENGINEERS",
    count: "50+",
  },
  {
    iconSrc: "/assets/icons/project.svg",
    title: "PROJECTS DELIVERED",
    count: "100+",
  },
  {
    iconSrc: "/assets/icons/delivery.svg",
    title: "ON TIME DELIVERY",
    count: "98%",
  },
]
const ImpactFulComponent = () => {
  return (
    <Wrapper>
      <AosWrapper>
        <Container>
          <CompanyDetails>
            {impactfulData?.map((data, i) => {
              return (
                <Card key={i}>
                  <img
                    src={data.iconSrc}
                    alt="icon"
                    className={"image"}
                    width={40}
                    height={40}
                  />
                  <Count>{data.count}</Count>
                  <Title>{data.title}</Title>
                </Card>
              )
            })}
          </CompanyDetails>
          <CompanyDescription>
            <div className={"title-container"}>
              <span className={"title"}>{"Let’s build something"}</span>
              <StyledGradientTitle>{"impactful"} </StyledGradientTitle>
              <span className={"title"}>{"together."}</span>
            </div>
            <p>
              {
                "Talk to our team and discover how we can support your next project."
              }
            </p>
          </CompanyDescription>
          <ButtonContainer>
            <Button
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/company/readytowork-corp/"
                )
              }
            >
              Contact Us
            </Button>
            <span>
              <img src="/assets/imgs/cta-arrow.svg" alt="arrow-right" />
            </span>
          </ButtonContainer>
        </Container>
      </AosWrapper>
    </Wrapper>
  )
}

export { ImpactFulComponent }
